module.exports = __webpack_public_path__ + "img/IconoMicrooperforado.05893a3e.png";